//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return {
           currentValue:'',
           currentverify:false,
        }
    },
    props: {
        verify:{ // 是否验证失败
            type: Object,
            default() { return {valid:false}; }
        },
        placeholder:{ // placeholder 文字
            type: String,
            default() { return ''; }
        },
        value: [String, Number],
        label: String,
        disabled: Boolean,
        max:Number
    },
    watch:{
      value(valueNew, valueOld){
        this.currentValue = valueNew
        this.currentverify = false
      },
      verify(valueNew, valueOld){
        this.currentverify = valueNew.valid
      }
    },
    created() {
        this.currentValue = (this.value === undefined || this.value === null) ? '' : this.value;
        this.currentverify = this.verify.valid

    },
    methods:{
        scrollInto(){
          window.setTimeout(function () {
              const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop ;
              if(scrollHeight){
                  window.scrollTo(0, Math.max(scrollHeight - 1, 0));
              }
              //console.log(Math.max(scrollHeight - 1, 0))
          }, 0);
          this.$emit("blur")
        },
        
    }
}
